// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"4a0c0279","302":"b0a34821","445":"7745d3f5","974":"4145092e"}[chunkId] + ".chunk.js";
};